import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface AdminAuthGuardProps {
  children: React.ReactNode;
}

export default function AdminAuthGuard({ children }: AdminAuthGuardProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [authorized, setAuthorized] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (!token && location.pathname !== '/admin/login') {
      navigate('/admin/login');
    } else {
      setAuthorized(true);
    }
    setChecking(false);
  }, [navigate, location.pathname]);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="flex items-center gap-2 text-sm text-foreground-500">
          <i className="ri-loader-4-line animate-spin" />
          验证中...
        </div>
      </div>
    );
  }

  if (!authorized) return null;

  return <>{children}</>;
}